import { useState } from 'react'
import { LuX } from 'react-icons/lu'
import { Box, Flex } from '@chakra-ui/react'

import LeidModal from 'components/ui/Modal/LeidModal'

type Props = {
  imageUrl: string
}

const ImageWithPreview = ({ imageUrl }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <LeidModal
        isOpen={isOpen}
        onClose={handleClose}
        size={{ mdDown: 'cover', md: 'xl' }}
        header={
          <Flex justifyContent="end" alignItems="center" width="100%">
            <LuX size={32} onClick={handleClose} />
          </Flex>
        }
      >
        <Flex width="100%" height="100%" justifyContent="center" alignItems="center">
          <img src={imageUrl} />
        </Flex>
      </LeidModal>

      <Box
        borderRadius="{borderRadius.big}"
        background="white"
        borderWidth="1px"
        borderColor="green.a200"
        padding="5px"
        onClick={handleOpen}
      >
        <img width="100px" height="100px" src={imageUrl} />
      </Box>
    </>
  )
}

export default ImageWithPreview
